import { useEffect } from 'react';
import { type Embed as EmbedType } from 'types/capi/content';

import useEnv from '~/hooks/useEnv';
import sdks from '~/utils/sdks';

const Embed = ({ embed }: { embed: EmbedType }) => {
  switch (embed.site) {
    case 'facebook':
      return <FacebookEmbed url={embed.url} />;
    case 'twitter':
      return <TwitterEmbed html={embed.html} />;
    case 'instagram':
      return <InstagramEmbed html={embed.html} />;
    case 'tiktok':
      return <TikTokEmbed html={embed.html} />;
    default:
      return null;
  }
};

const FacebookEmbed = ({ url }: { url: EmbedType['url'] }) => {
  const { FACEBOOK_APP_ID } = useEnv();

  useEffect(() => {
    sdks.injectFacebook(FACEBOOK_APP_ID);
  }, [FACEBOOK_APP_ID]);

  return (
    <div className="flex w-full justify-center overflow-x-scroll text-center">
      <div className="fb-post" data-href={url} />
    </div>
  );
};

const TwitterEmbed = ({ html }: { html: EmbedType['html'] }) => {
  useEffect(() => {
    sdks.injectTwitter();
  }, []);

  return html ? (
    <div
      className="twitter-post-embed flex w-full justify-center"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : null;
};

const InstagramEmbed = ({ html }: { html: EmbedType['html'] }) => {
  useEffect(() => {
    sdks.injectInstagram();
  }, []);

  return html ? (
    <div
      className="instagram-post-embed flex w-full justify-center"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : null;
};

const TikTokEmbed = ({ html }: { html: EmbedType['html'] }) => {
  return html ? (
    <div
      className="flex w-full justify-center"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : null;
};

export default Embed;
